import { Component, EventEmitter, Output, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PlgContact, PlgTokenService } from '../../services/plg-token.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
    @Output() menuToggle = new EventEmitter<void>();

    private readonly plgToken = inject(PlgTokenService);

    // Reactive so a silent re-bootstrap (which populates `contact` after the
    // header has already mounted) refreshes the displayed name.
    readonly displayName$: Observable<string> = this.plgToken.contact$.pipe(map(toDisplayName));

    onMenuToggle(): void {
        this.menuToggle.emit();
    }
}

function toDisplayName(contact: PlgContact | null): string {
    if (!contact) return '';
    return [contact.firstname, contact.lastname].filter((p): p is string => !!p?.trim()).join(' ');
}
